var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonIconDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 19C3.95 19 3.47933 18.8043 3.088 18.413C2.69667 18.0217 2.50067 17.5507 2.5 17V4H1.5V2H6.5V1H12.5V2H17.5V4H16.5V17C16.5 17.55 16.3043 18.021 15.913 18.413C15.5217 18.805 15.0507 19.0007 14.5 19H4.5ZM6.5 15H8.5V6H6.5V15ZM10.5 15H12.5V6H10.5V15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonIconDelete);
export default __webpack_public_path__ + "static/media/buttonIconDelete.208c38381274655eac94f6887faf7940.svg";
export { ForwardRef as ReactComponent };